var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTag = function SvgIconTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#24292D",
    d: "M8.056 3.007a.5.5 0 0 1 .437.139l5.598 5.599a.5.5 0 0 1 0 .707l-4.639 4.64a.5.5 0 0 1-.707 0l-5.599-5.6a.5.5 0 0 1-.14-.437l.673-3.968a.5.5 0 0 1 .409-.41zm-.088 1.029-3.363.57-.57 3.362 5.063 5.062 3.932-3.932zM6.461 5.61a.5.5 0 1 1-.709.707.5.5 0 0 1 .709-.707"
  })));
};
export default SvgIconTag;